import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerTicketListScreen from './screens/MaintainerTicketListScreen';
import MaintainerTicketDetailScreen from './screens/MaintainerTicketDetailScreen';

function MaintainerTicket(props) {
    const { isMine } = props;

    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<MaintainerTicketListScreen isMine={isMine} />} />
                    <Route path="/:ticketId" element={<MaintainerTicketDetailScreen isMine={isMine} />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerTicket;
